import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Lockup } from "@ds/Mark";
import "./top-nav.css";

const NAV_ITEMS = [
  { to: "/products", label: "Products" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" }
] as const;

export function TopNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [elevated, setElevated] = useState(false);
  const location = useLocation();
  const lastFocusRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <header className={`top-nav${elevated ? " top-nav--elevated" : ""}`}>
      <div className="container top-nav__inner">
        <Link to="/" className="top-nav__brand" aria-label="StageGrid Systems home">
          <Lockup size={26} />
        </Link>
        <nav className="top-nav__links" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `top-nav__link${isActive ? " top-nav__link--active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="top-nav__actions">
          <Link to="/contact?topic=byr-beta" className="sgs-btn sgs-btn--primary sgs-btn--sm">
            Tester program
          </Link>
          <button
            ref={lastFocusRef}
            type="button"
            className="top-nav__menu-btn"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            aria-controls="primary-mobile-nav"
            onClick={() => setMobileOpen((v) => !v)}
          >
            {mobileOpen ? <X size={18} aria-hidden /> : <Menu size={18} aria-hidden />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="top-nav__mobile" id="primary-mobile-nav">
          <nav className="top-nav__mobile-links" aria-label="Primary mobile">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `top-nav__mobile-link${isActive ? " top-nav__mobile-link--active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact?topic=byr-beta" className="sgs-btn sgs-btn--primary" style={{ marginTop: "var(--sgs-space-3)" }}>
              Tester program
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
